import { th } from "intl-tel-input/i18n";

// @ts-check
export class Register{
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main,state){
this.controller = new AbortController();
this.cleanups = [];
this.evtHandlers = [];
this.main = main;
this.state = state;
this.getTemplate();
}//

getTemplate(){
let $this = this;
this.registerComponent = this.main.pbu.createElement('main',['form-signin','w-100','m-auto']);
this.registerComponent.innerHTML = 
`
<p class="text-center"><img class="mb-4" src="https://r2.senplat.com/public/default/sp_logo.png" alt="" width="72" height="57"></p>
    <h3 class="h3 mb-3 fw-normal sp-title">Register</h3>
  <form class="auth">
    <section'>
    ${this.main.pbu.createFormControl({serialize:true,title:"First Name",clasz:['first-name','sp-validation-required']})}
    ${this.main.pbu.createFormControl({serialize:true,title:"Last Name",clasz:['last-name','sp-validation-required']})}
     ${this.main.pbu.createFormControl({serialize:true,title:"Email",type:'email',clasz:['email','sp-validation-required']})}
    ${this.main.pbu.createFormControl({serialize:true,title:"Password",type:'password',clasz:['password','sp-validation-required']})}
    <p class="text-center small"><a href="/app/login">Already have an account? Log in</a></p>
   </section>
  </form>
`;
this.main.pbu.mount(this.registerComponent);
//
this.authForm = this.registerComponent.querySelector('form.auth');
this.formTitle = this.registerComponent.querySelector('h3.sp-title');
this.firstNameControl = this.registerComponent.querySelector('input.first-name');
this.lastNameControl = this.registerComponent.querySelector('input.last-name');
this.emailControl = this.registerComponent.querySelector('input.email');
this.passwordControl = this.registerComponent.querySelector('input.password');
this.authForm.appendChild(this.main.tu.getSaveButton({component:this,cb:this.getToken,cbIsMain:true,textContent:'Register',clasz:['w-100']}));
//
addEvents();
this.cleanups.push(()=>{$this  = null;});

function addEvents(){
}//inner
}//func
/**
 * 
 * @returns check if tenant exist, if not, send auth token to verify email
 */
async getToken(){
if(! this.main.vu.validate(this.authForm.querySelectorAll('input.sp-validation'))){
    return;
}
this.tenant = {
firstName:this.firstNameControl.value,
lastName:this.lastNameControl.value,
email: this.emailControl.value,
password:this.passwordControl.value,
clientUUID:this.main.utils.getUUID()
};
//dont springify a single value like email else extra double quote will be added
let r = await this.main.fu.fetch({
  link:this.main.fu.getApi('exists'),
  body:this.tenant.email
});

if(r){
if(r=='exists'){
this.main.utils.notify('Record exists',{level:0});
}else{
this.authTokenTemplate = this.main.tu.authToken({component:this,cb:this.register,tokenUuid:r,cbIsMain:true,withTimer:true,email:this.tenant.email});
this.main.pbu.replace(this.authForm,this.authTokenTemplate);
}


}
}//func

async register(){
let r = await this.main.fu.fetch({
  link: this.main.fu.getApi('register'),
  body:JSON.stringify(this.tenant)
});
if(r){
this.main.utils.setCache('user',r.user);
this.main.utils.setCache('option',r.option);
this.formTitle.textContent = 'Thank you, please visit your dashboard';
//display link of dashboard; 
let href = 'https://' + r.user.username + '.' +this.main.siteDomain + this.main.getLink('dashboard');
if(this.main.isDev()){
href = `http://localhost:5173/testuser/${r.user.username}/login`;
}
this.main.log(href,'Register.register()  new tenant dashboard link');
this.authForm.innerHTML = `<a target="_blank" href="${href}" class="sp-btn btn btn-primary w-100 py-2" >Dashboard</button>`;
}
}
/**
 * 
 * @param {string} tokenUuid 
 * @returns 
 */
async validateToken(tokenUuid){
let r = await this.main.fu.fetch({
  link:this.main.fu.getApi('validate-token'),
  body:JSON.stringify(tokenUuid)
});
return r;
}//func

}//#class
